import { useState, useRef, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams, useNavigate } from 'react-router-dom';
import BreadCrumb from '../../../../component/BreadCrumb';
import InputBox from '../../../../component/InputBox';
import TextViewer from '../../../../component/editor/TextViewer';
import CommunityPostEditorInfoBox from '../../../../component/CommunityPostEditorInfoBox';
import CommunityDeleteButtonBox from '../../../../component/buttons/CommunityDeleteButtonBox';
import CommunityEditButtonBox from '../../../../component/buttons/CommunityEditButtonBox';
import ConfirmButtonBox from '../../../../component/buttons/ConfirmButtonBox';
import { COMMUNITY_FAQ_EDIT_PATH, COMMUNITY_FAQ_PATH, PATH_DELIMITER, ROLE } from '../../../../constant/Constant';
import PopupRef from '../../../../component/PopupRef';
import { actionRemove, actionDetail } from '../../../../module/body/community/faq/CommunityFaqModule';
import { VIEW_COMMUNITY_FAQ_DETAIL } from '../../../../constant/ViewConstant';
import NullCheckUtil from '../../../../util/NullCheckUtil';
import CodeUtil from '../../../../util/CodeUtil';
import AuthenticationUtil from '../../../../util/AuthenticationUtil';
import { CODE_GROUP_ID } from '../../../../constant/Constant';

const CommunityFaqDetailView = () => {
    let params = useParams();

    const [postingNo, setPostingNo] = useState(params && params.postingNo);
    const [postingTitleNm, setPostingTitleNm] = useState('');
    const [postingCtnt, setPostingCtnt] = useState('');
    const [universityNm, setUniversityNm] = useState('');
    const [userNm, setUserNm] = useState('');
    const [regDttm, setRegDttm] = useState('');
    const [editPermission, setEditPermission] = useState(false);
    const [deletePermission, setDeletePermission] = useState(false);

    const navigate = useNavigate();
    const dispatch = useDispatch();
    const popupRef = useRef(null);

    useEffect(() => {
        window.scrollTo(0, 0);
        initSearch(params.postingNo);
    }, []);

    const initSearch = (postingNo) => {
        dispatch(
            actionDetail({
                params: { postingNo },
                callback: (result) => {
                    setDetail(result);
                },
            }),
        );
    };

    const setDetail = (result) => {
        setPostingTitleNm(result.postingTitleNm);
        setPostingCtnt(result.postingCtnt);
        if (NullCheckUtil.isNotEmpty(result.userUniversityCd)) {
            setUniversityNm(
                CodeUtil.getCodes(CODE_GROUP_ID.USER_UNIVERSITY).find((el) => el.cd == result.userUniversityCd).cdNm,
            );
        }
        setUserNm(result.userNm);
        setRegDttm(result.regDttm);

        if (
            AuthenticationUtil.getUserRoleCd() == ROLE.ADMIN ||
            (AuthenticationUtil.getUserRoleCd() == ROLE.STAFF && AuthenticationUtil.getUserId() == result.regUserId)
        ) {
            setEditPermission(true);
            setDeletePermission(true);
        }
    };

    const handleDelete = () => {
        popupRef.current.openWarning('FAQ ' + postingNo + '(을)를 삭제하시겠습니까?', () => {
            return function () {
                dispatch(
                    actionRemove({
                        params: { postingNo },
                        callback: (pno) => {
                            popupRef.current.openInfo(
                                '게시물 번호 ' + pno + '(가)이 삭제되었습니다. FAQ 목록으로 이동합니다.',
                                () => {
                                    return function () {
                                        navigate(COMMUNITY_FAQ_PATH);
                                    };
                                },
                            );
                        },
                    }),
                );
            };
        });
    };

    const handleEdit = () => {
        var path = COMMUNITY_FAQ_EDIT_PATH + PATH_DELIMITER + postingNo;
        navigate(path);
    };

    const handleConfirm = () => {
        navigate(COMMUNITY_FAQ_PATH);
    };

    return (
        <section className='container'>
            <div className='container-inner'>
                <div className='con-title-wrap conbg04'>
                    {/* <h2 className='con-title'>FAQ</h2> */}
                    <h2 className='con-title'>{VIEW_COMMUNITY_FAQ_DETAIL.title}</h2>
                    <p className='con-title-p'>{VIEW_COMMUNITY_FAQ_DETAIL.subTitle}</p>
                </div>
                <div className='sub-nav-wrap'>
                    <BreadCrumb />
                </div>
                <div className='community-wrap'>
                    <div className='cmnty-top-box'>
                        <div className='top-box-row full'>
                            <InputBox
                                title='제목'
                                disabled={true}
                                value={postingTitleNm}
                                onChange={(e) => setPostingTitleNm(e.target.value)}
                            />
                        </div>
                    </div>
                    <TextViewer className='cmnty-textarea-box' value={postingCtnt} />
                    <CommunityPostEditorInfoBox userNm={userNm} universityNm={universityNm} regDttm={regDttm} />
                    <div className='cmnty-btn-box btn-wrap'>
                        {deletePermission && <CommunityDeleteButtonBox title='삭제' onClick={(e) => handleDelete()} />}
                        {editPermission && <CommunityEditButtonBox title='편집' onClick={(e) => handleEdit()} />}
                        <ConfirmButtonBox title='확인' onClick={(e) => handleConfirm()} />
                    </div>
                </div>
            </div>
            <PopupRef ref={popupRef} />
        </section>
    );
};

export default CommunityFaqDetailView;
